<template>
    <base-view class="form-view">
        <slot name="before"></slot>
        <slot></slot>
        <veui-form
            ref="form"
            v-bind="store.formSetting"
            :data="store.formData"
            @submit="handleSubmit"
            @invalid="handleInvalid"
        >
            <slot name="field"></slot>
            <div class="form-operation" v-if="$slots.operation">
                <slot name="operation"></slot>
            </div>
        </veui-form>
        <slot name="after"></slot>
    </base-view>
</template>

<script>
import {Form} from 'veui';
import BaseView from './BaseView';
import FormModel from './FormModel';
import createView from './createView';
import {each, get, includes} from 'lodash';
import {isType} from '../utils/helper';

export default createView(BaseView, FormModel, {
    name: 'form-view',
    components: {
        'veui-form': Form
    },
    props: {
        initialData: null
    },
    created() {
        this.store.initFormData(this.initialData);
    },
    methods: {
        submit() {
            this.$refs.form.submit();
        },
        validate(...args) {
            return this.$refs.form.validate(...args);
        },
        reset(...args) {
            this.$refs.form.reset(...args);
        },
        async handleSubmit(data) {
            try {
                this.handleSuccess(await this.store.submit(data));
            }
            catch (error) {
                this.handleError(error);
            }
        },
        findChildField(component, fields) {
            if (!component.$children || !component.$children.length) {
                return;
            }

            let field;
            component.$children.some(child => {
                if (isType(child, 'field') && includes(fields, child.name)) {
                    field = child;
                    return true;
                }

                let temp = this.findChildField(child, fields);
                if (temp) {
                    field = temp;
                    return true;
                }

                return false;
            });
            return field;
        },
        findFirstErrorField(vNodes, fields) {
            let field;
            vNodes.some(vNode => {
                if (vNode.componentInstance) {
                    if (isType(vNode.componentInstance, 'field')) {
                        field = vNode.componentInstance;
                    }
                    else {
                        field = this.findChildField(vNode.componentInstance, fields);
                    }
                }
                else if (vNode.children) {
                    field = this.findFirstErrorField(vNode.children, fields);
                }

                return !!field && field.validities.length > 0 && (!fields || includes(fields, field.name));
            });
            return field;
        },
        scrollToErrorField(field) {
            field = field.$el || field;
            let filedTop = field.getBoundingClientRect().top;
            let {scrollFix, scrollBehavior} = this.store;
            let top = document.documentElement.scrollTop + filedTop + scrollFix;

            if (getComputedStyle(document.documentElement).scrollBehavior) {
                window.scroll({
                    top,
                    behavior: scrollBehavior
                });
            }
            else {
                window.scroll(0, top);
            }
        },
        handleErrorScroll(fields) {
            if (!this.store.scrollToFirstError) {
                return;
            }

            let vNodes = this.$refs.form.$slots.default || [];
            let field = this.findFirstErrorField(vNodes, fields);
            if (field) {
                this.scrollToErrorField(field);
            }
        },
        handleInvalid(err) {
            this.store.invalid(err);
            this.$emit('invalid', err);
            this.handleErrorScroll(Object.keys(err));
        },
        handleSuccess(res) {
            this.store.successToast && this.showToast(this.store.successToast, {type: 'success'});
            this.$refs.form.fields.forEach(field => field.hideValidity());
            this.store.success(res);
            this.$emit('submitsuccess', res);
        },
        handleError(err) {
            this.store.failToast && this.showToast(this.store.failToast, {type: 'error'});
            // 处理一下 fieldsError
            let fields = err.fields || err.field;
            if (fields) {
                each(fields, (message, name) => {
                    let target = get(this, `$refs.form.fieldsMap['${name}']`);
                    target && target.validities.unshift({
                        valid: false,
                        message,
                        fields: 'backend:field'
                    });
                });
                this.handleErrorScroll(Object.keys(fields));
            }
            this.store.fail(err);
            this.$emit('submitfail', err);
        }
    }
});
</script>

<style lang="less">
@import '../assets/css/variables';

.form-operation {
    margin-left: @ria-form-label-width;
    margin-top: 60px;

    .veui-button {
        margin-right: 20px;
    }

    &:empty {
        margin-top: 0;
    }
}
</style>
